import { createSelector } from 'reselect'

import selectIntegrationCredentialsBase from './selectIntegrationCredentialsBase'

export default createSelector(
  selectIntegrationCredentialsBase,
  ({ byId } = {}) => byId || {}
)
